(function () {
  if (window.__slSignupLoaded) return;
  window.__slSignupLoaded = true;

  /* Signup forms are Shopify customer (newsletter) forms — see
     snippets/sl-signup-form.liquid. They post normally: this script only
     validates before the post, then on the page Shopify returns to
     (?customer_posted=true#<form id>) shows the thank-you in the form that
     was used and publishes the Pinterest conversion event.
     A normal post (not fetch) so Shopify's own bot protection (hCaptcha)
     can step in when it wants to; a background post would fail silently.

     Shopify binds an invisible hCaptcha to the form when a field is first
     focused. Its submit handler always cancels the post, runs the captcha
     and then posts via form.submit() — even if another handler rejected the
     input. So validation runs in a window-level capture listener (before
     anything on the form) and stops the event entirely when input is bad. */

  /* --- Attribution: remember where this visitor came from ----------------
     Written on first arrival. Until Oct 2026 it was sent to Mailchimp as
     merge fields; Shopify's customer form has no field for it, so it is
     currently only stored, not sent.                                      */

  var ATTR_KEY     = 'sl_attr';
  var ATTR_MAX_AGE = 30 * 24 * 60 * 60 * 1000; // 30 days, matches Pinterest

  function readAttr() {
    try {
      var raw = localStorage.getItem(ATTR_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (o && o.t && (Date.now() - o.t) < ATTR_MAX_AGE) return o;
    } catch (e) {}
    return null;
  }

  function writeAttr(o) {
    try { localStorage.setItem(ATTR_KEY, JSON.stringify(o)); } catch (e) {}
  }

  function captureAttr() {
    var params;
    try { params = new URLSearchParams(window.location.search); }
    catch (e) { return; }

    // A tagged link always wins, and refreshes the 30-day window.
    var src = params.get('utm_source');
    if (src) {
      writeAttr({
        s: src,
        c: params.get('utm_campaign') || '',
        n: params.get('utm_content')  || '',
        t: Date.now()
      });
      return;
    }

    // Otherwise keep whatever we already have.
    if (readAttr()) return;

    // No tag, nothing stored: fall back to the referring site.
    // This is what catches ORGANIC Pinterest traffic.
    var ref = document.referrer || '';
    if (!ref) return;
    var host = '';
    try { host = new URL(ref).hostname.replace(/^www\./, ''); }
    catch (e) { return; }
    if (!host || host === window.location.hostname) return;
    writeAttr({ s: host + ' (referral)', c: '', n: '', t: Date.now() });
  }

  captureAttr();

  var TEXT = {
    working: 'Sending…',
    successHtml:
      '<p class="sl-signup__message-title">Thank you!</p>' +
      '<p class="sl-signup__message-body">You will receive an email with your discount code. ' +
      'If you don\'t see it, please check your spam.<br>' +
      'I look forward to staying in touch!<br>' +
      'Sarah-Linda</p>',
    noName:  'Please enter your first name.',
    invalid: 'Please enter a valid email address.'
  };

  // Same cookie the theme's own popup component reads on mount to decide
  // whether to show at all (uv.get('sl-newsletter-popup-hide')). Setting it
  // ourselves — with our own duration — overrides the theme's default here.
  var POPUP_HIDE_COOKIE = 'sl-newsletter-popup-hide';
  function setPopupHideCookie(days) {
    document.cookie = POPUP_HIDE_COOKIE + '=true; max-age=' + (days * 24 * 60 * 60) + '; path=/';
  }

  // Set once this visitor has subscribed, so closing the popup afterwards
  // keeps the 365-day hide instead of shortening it to a day.
  var subscribed = false;

  // The theme's built-in close button always hides the popup for 365 days.
  // We want that only for an actual subscribe; a plain close should be much
  // shorter, so re-set the cookie right after the theme's own handler runs.
  function wireClosePopupCookie() {
    var btn = document.querySelector('.newsletter-popup__close-button');
    if (!btn || btn.dataset.slPopupCloseWired) return;
    btn.dataset.slPopupCloseWired = '1';
    btn.addEventListener('click', function () { setPopupHideCookie(subscribed ? 365 : 1); });
  }

  /* --- Between the post and the page Shopify returns to ------------------
     sessionStorage carries which form was used (and the name/email for the
     Pinterest event) across the full page load.                           */

  var PENDING_KEY = 'sl_signup_pending';

  function savePending(o) {
    try { sessionStorage.setItem(PENDING_KEY, JSON.stringify(o)); } catch (e) {}
  }
  function takePending() {
    try {
      var raw = sessionStorage.getItem(PENDING_KEY);
      sessionStorage.removeItem(PENDING_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  // The homepage banner form also uses the "popup" styling variant, so the
  // real popup is recognised by its container, not by the variant class.
  function sourceOf(form) {
    if (form.closest('.newsletter-popup__layout')) return 'popup';
    if (form.closest('.sl-signup--footer')) return 'footer';
    return 'landing-section';
  }

  // Success replaces the whole intro (heading/body/form) with a thank-you
  // message in the same space, rather than showing it alongside the form.
  function showSuccess(form) {
    var root    = form.closest('.sl-signup');
    var intro   = root.querySelector('[data-sl-intro]');
    var success = root.querySelector('[data-sl-success]');
    intro.hidden = true;
    success.innerHTML = TEXT.successHtml;
    success.hidden = false;
    return success;
  }

  // The theme's popup component keeps its open state privately, so to show
  // the thank-you after a popup signup we open it by its data-state
  // attributes and close it the same way. (Its own close handler sets a
  // state that is already "closed", so Vue would not re-render it shut.)
  function openPopupWithSuccess() {
    var overlay   = document.querySelector('.newsletter-popup__overlay');
    var container = document.querySelector('.newsletter-popup__container');
    if (!overlay || !container) return;

    function setState(state) {
      overlay.setAttribute('data-state', state);
      container.setAttribute('data-state', state);
    }
    function close() {
      setState('closed');
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    setState('open');
    var btn = container.querySelector('.newsletter-popup__close-button');
    if (btn) btn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', onKey);
  }

  function publishSignup(pending) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('newsletter_signup', {
          email: pending.email,
          first_name: pending.first,
          event_id: 'sl-' + Date.now() + '-' + Math.floor(Math.random() * 1e6),
          source: pending.source
        });
      }
    } catch (err) { /* tracking must never break the signup itself */ }
  }

  // Runs on every init until it finds the form, because the popup's markup
  // is mounted by Vue and may not exist on the first pass.
  var returned = null;
  function checkReturn() {
    if (returned === false || (returned && returned.done)) return;
    if (returned === null) {
      if (!/[?&]customer_posted=true/.test(window.location.search)) { returned = false; return; }
      var pending = takePending();
      var hashId = (window.location.hash || '').replace(/^#/, '');
      var id = hashId || (pending && pending.id) || '';
      // Only our own forms: the event page posts the same customer form.
      if (!/^slsignup-/.test(id)) { returned = false; return; }
      returned = { id: id, pending: pending && pending.id === id ? pending : null, done: false };
    }

    var form = document.getElementById(returned.id);
    if (!form) return;
    returned.done = true;
    subscribed = true;

    var success = showSuccess(form);
    // A subscriber shouldn't be offered the popup again, whichever form they used.
    setPopupHideCookie(365);
    if (sourceOf(form) === 'popup') {
      openPopupWithSuccess();
    } else {
      // Shopify's #anchor pointed at the form, which is now hidden.
      try { success.scrollIntoView({ block: 'center' }); } catch (e) {}
    }

    if (returned.pending) publishSignup(returned.pending);
  }

  function say(form, text, state) {
    var msg = form.querySelector('[data-sl-message]');
    msg.textContent = text;
    msg.setAttribute('data-state', state || 'info');
  }

  function reject(e, form, input, text) {
    e.preventDefault();
    e.stopImmediatePropagation(); // keep Shopify's captcha handler from posting it anyway
    input.setAttribute('aria-invalid', 'true');
    say(form, text, 'error');
    input.focus();
  }

  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-sl-signup')) return;

    var email = form.querySelector('input[name="contact[email]"]');
    var fname = form.querySelector('input[name="contact[first_name]"]');
    var label = form.querySelector('[data-sl-label]');
    var first = (fname.value || '').trim();
    var mail  = (email.value || '').trim();

    if (!first) { reject(e, form, fname, TEXT.noName); return; }
    fname.removeAttribute('aria-invalid');

    if (!mail || !email.checkValidity()) { reject(e, form, email, TEXT.invalid); return; }
    email.removeAttribute('aria-invalid');

    // Valid: Shopify's captcha (or the browser) takes it from here.
    fname.value = first;
    email.value = mail;
    savePending({ id: form.id, email: mail, first: first, source: sourceOf(form) });
    say(form, '', 'info');
    if (!label.dataset.idle) label.dataset.idle = label.textContent;
    label.textContent = TEXT.working;
    // If the visitor abandons a captcha challenge the page stays put;
    // don't leave the button saying "Sending…" for ever.
    setTimeout(function () { label.textContent = label.dataset.idle; }, 8000);
  }, true);

  function wire(form) {
    if (form.dataset.slWired) return;
    form.dataset.slWired = '1';
    form.noValidate = true;
  }

  function init() {
    document.querySelectorAll('[data-sl-signup]').forEach(wire);
    wireClosePopupCookie();
    checkReturn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Back after a popup signup returns to the page the form was sent from.
  // Browsers that restore it from their back/forward cache show it exactly
  // as it was left - with the popup open on the signup form. The hide cookie
  // set on the return page means this visitor has signed up (or dismissed
  // the popup), so close it the same way openPopupWithSuccess does.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || document.cookie.indexOf(POPUP_HIDE_COOKIE + '=') === -1) return;
    document.querySelectorAll('.newsletter-popup__overlay, .newsletter-popup__container').forEach(function (el) {
      el.setAttribute('data-state', 'closed');
    });
  });

  // Popups often inject late, and the theme editor re-renders sections.
  document.addEventListener('shopify:section:load', init);
  setTimeout(init, 1500);
  setTimeout(init, 4000);
})();
